import { useSearchParams } from 'react-router-dom'
import { useInventorySystemProfiles } from '../../hooks/useInventorySystemProfiles'
import { useVenues } from '../../hooks/useVenues'
import { CreateEntityPage } from '../CreateEntityPage/CreateEntityPage'
import { createInventorySystemProfileToVenue } from '../../services/api/createInventorySystemProfileToVenue'
import type { FieldDef } from '../../types'
import { formatVenueSlugLabel } from '../../helpers/formatVenueSlugLabel'

export function CreateInventorySystemProfileToVenuePage() {
  const {
    profiles,
    isLoading: profilesLoading,
    error: profilesError,
  } = useInventorySystemProfiles()
  const { venues, isLoading: venuesLoading, error: venuesError } = useVenues()

  const [searchParams] = useSearchParams()
  const preselectedVenueId = searchParams.get('venueId') ?? undefined
  const isLoading = profilesLoading || venuesLoading
  const loadError = profilesError ?? venuesError

  const fields: FieldDef[] = [
    {
      name: 'inventorySystemProfileId',
      label: 'ISP Profile',
      type: 'select',
      searchable: true,
      options: profiles.map((p) => ({
        value: p.id,
        label: `${p.code} (${p.id})`,
      })),
      valueType: 'number',
    },
    {
      name: 'venueId',
      label: 'Venue',
      type: 'select',
      searchable: true,
      options: venues.map((v) => ({
        value: v.id,
        label: formatVenueSlugLabel(v),
      })),
      defaultValue: preselectedVenueId,
    },
  ]

  return (
    <CreateEntityPage
      title="Create ISP to Venue Mapping"
      backTo="/isp-to-venues"
      isLoading={isLoading}
      loadError={loadError}
      fields={fields}
      createFn={createInventorySystemProfileToVenue}
    />
  )
}
